export default function MySQL_DELETE() {
  return (
    <div>
      <h2>MySQL_DELETE</h2>    </div>
  );
}